import { AppShell } from "@/components/AppShell.tsx";
import { CatalogProvider } from "@/lib/catalog/context.tsx";

export function App() {
  return (
    <CatalogProvider>
      <AppShell />
    </CatalogProvider>
  );
}
